export default __webpack_public_path__ + "static/media/motorcycle.d02e0aab.svg";